import React, { useEffect, useState } from 'react'
import { useAuthState } from 'react-firebase-hooks/auth';
import axios from 'axios';
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardText,
    FormGroup,
    Form,
    Input,
    Row,
    Col
} from "reactstrap";
import { auth } from '../../firebase/firebase-config';
import firebase from '../../firebase/firebase-config';
import { Link, useParams } from 'react-router-dom';
import Order_product_tab from './Order_product_tab';
import './Order.css';
import 'react-toastify/dist/ReactToastify.css';
import { toast, Toast, ToastContainer } from 'react-toastify';
import { updateToken } from '../../authPages/BaseRequester';
import { v4 as uuidv4 } from 'uuid';

const ViewOrder = () => {
    const params = useParams();

    const [user, loading] = useAuthState(auth);
    const [Order_data, setOrder_data] = useState({});
    const [mydate, setdate] = useState();
    const [order_user, setorder_user] = useState({});
    const [order_products, setorder_products] = useState();
    const [order_status, setorder_status] = useState({ status: '' });
    const [order_status_update, setorder_status_update] = useState({ status: order_status.status });

    useEffect(() => {
        GetMyUser();


    }, [])
    async function GetMyUser() {
        try {
            console.log(params.id);

            firebase.firestore().collection('orders').doc(params.id).onSnapshot((snapshot) => {
                console.log(snapshot.data());

                // const dates = new Date(snapshot.data()['date'].);
                const user_id = snapshot.data()['userId'];
                const all_products = snapshot.data()['products'];

                // setdate(dates.toUTCString());
                setOrder_data(snapshot.data());
                setorder_products(all_products);
                firebase.firestore().collection('users').doc(user_id).onSnapshot((data) => {
                    setorder_user(data.data());

                })
            })



        } catch (error) {
            console.log(error);
        }



    }

    useEffect(() => {
        var Order_status = '';
        firebase.firestore().collection('orders').doc(params.id).onSnapshot((snapshot) => {
            console.log(snapshot.data());
            Order_status = snapshot.data()['status'];
            console.log(Order_status);
            setorder_status({ status: Order_status });

        });


    }, [])


    console.log(Order_data);
    function printDiv() {
        var divContents = document.getElementById("Email_data").innerHTML;
        var a = window.open('', '', 'height=800, width=800');
        a.document.write('<html>');
        a.document.write('<body >');
        a.document.write(divContents);
        a.document.write('</body></html>');
        a.document.close();
        a.print();
    }

    const options_status = [

        {

            label: "Pending",

            value: "pending",

        },

        {

            label: "Approved",

            value: "approved",

        },

        // {

        //     label: "Production",

        //     value: "production",

        // },

        {

            label: "Out For Delivery",

            value: "shipped",

        },

        {

            label: "Delivered",

            value: "delivered",

        },


    ];



    const changeOrderStatus = async () => {
        var token = await updateToken();
        const header = `Authorization: Bearer ${token}`;
        const config = {
            headers: { "Authorization": `Bearer ${token}` }
        }
        const uuid =
            uuidv4();
        console.log(order_status_update)
        const postRy = [];
        const order = await firebase.firestore().collection('orders').doc(params.id);
        const data = await firebase.firestore().collection('orders').doc(params.id).get();
        const productData = await data.data()['products'];
        console.log(productData, 'this is produst');
        await order.update({ status: order_status_update.status });
        var NotificaitonData = {
            id: uuid,
            title: `Beyown Product Order Status`,
            message: `Your Order is ${order_status_update.status} For Order # ${Order_data?.orderId}, Tap to view more...`,
            icon: "",
            topics: "",
            data: {},
            type: "follow",
            // senderId: "",
            userId: order_user.id,
        }
        axios.post('https://us-central1-beyown-eead9.cloudfunctions.net/beyown/beyown/api/v1/user/sendNotification', NotificaitonData, config)

        if (order_status_update.status == 'approved') {
            await productData.forEach(async (dataPP) => {
                console.log(dataPP);
                postRy.push(dataPP.id)
                const soldN = await firebase.firestore().collection('posts').doc(dataPP.id).get();
                await console.log(soldN.data());
                const soldNUm = await soldN.data()['sold']
                if (soldNUm >= 0) {

                    await firebase.firestore().collection('posts').doc(dataPP.id).update({
                        'sold': soldNUm + 1,
                    });
                }
            });

        } else if (order_status_update.status == 'pending') {
            await productData.forEach(async (dataPP) => {
                console.log(dataPP.id);
                // postRy.push(dataPP.id)
                const soldN = await firebase.firestore().collection('posts').doc(dataPP.id).get();
                const soldNUm = await soldN.data()['sold']
                if (soldNUm >= 1) {

                    await firebase.firestore().collection('posts').doc(dataPP.id).update({
                        'sold': soldNUm - 1,
                    });
                }
            });
        }




        toast.success('Order Status Has been updated', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
        })

    }
    return (
        <>
            <div className="content">
                <Row>
                    <Col md="8" className="shadow-lg  rounded">
                        <Card>
                            <CardHeader>
                                <h5 className="title display-4">Order Details  - {Order_data?.orderId}</h5>
                                <h5>Order Created On : </h5>

                            </CardHeader>
                            <CardBody>
                                <p className="display-5 font-weight-bold">Customer And Order Details : </p>
                                <Row>
                                    <Col className="pr-md-1" md="6">
                                        <FormGroup>
                                            <label className=" font-weight-bold">Customer Full Name :</label>
                                            <label className=" "> {Order_data?.fullName}</label>

                                        </FormGroup>
                                        <FormGroup>
                                            <label className=" font-weight-bold">Customer Email :</label>
                                            <label className=" "> {Order_data?.email}</label>

                                        </FormGroup>
                                        <FormGroup>
                                            <label className=" font-weight-bold">Requested By User :</label>
                                            <Link to={`/admin/total-beyown-users/single_user/${order_user.id}`} ><label className=" font-weight-bold" style={{ cursor: 'pointer' }}> @{order_user.username} -- {order_user.fullName} </label></Link>

                                        </FormGroup>

                                        <FormGroup>
                                            <label className=" font-weight-bold">Shipment Type :</label>
                                            {Order_data?.shipmentType == "Rush" ? <label className="bg-success font-weight-bold text-white px-3 mx-2 rounded "> {Order_data?.shipmentType}</label> : <label className="bg-info text-white font-weight-bold px-3 mx-2 rounded "> {Order_data?.shipmentType}</label>}

                                        </FormGroup>

                                    </Col>
                                    <Col className="px-md-1" md="6">
                                        <FormGroup>
                                            <label className=" font-weight-bold">Customer User Name :</label>
                                            <Link to={`/admin/total-beyown-users/single_user/${order_user.id}`} ><label className=" font-weight-bold" style={{ cursor: 'pointer' }}> @{order_user.username} -- {order_user.fullName} </label></Link>


                                        </FormGroup>
                                        <FormGroup>
                                            <label className=" font-weight-bold">Customer Phone Number :</label>
                                            <label className=" ">{Order_data?.phoneNumber}</label>

                                        </FormGroup>
                                        <FormGroup>
                                            <label className=" font-weight-bold">Payment Method :</label>
                                            {Order_data?.paymentType == 'Stripe' ? <label className=" bg-light  px-3 mx-2 rounded text-info  font-weight-bold">{Order_data?.paymentType}</label> : <label className=" bg-warning  px-3 mx-2 rounded text-white  font-weight-bold">{Order_data?.paymentType}</label>}

                                        </FormGroup>



                                    </Col>

                                </Row>
                                <p className="display-5 font-weight-bold">Address/Location Details : </p>
                                <Row>
                                    <Col className="pr-md-1" md="6">
                                        <FormGroup>
                                            <label className=" font-weight-bold">Customer Address :</label>
                                            <label className=" "> {Order_data?.address}</label>

                                        </FormGroup>
                                    </Col>
                                    <Col className="pr-md-1" md="6">
                                        <FormGroup>
                                            <label className=" font-weight-bold">Location :</label>
                                            <label className=" "> {Order_data?.location}</label>

                                        </FormGroup>
                                    </Col>
                                </Row>
                                <p className="display-5 font-weight-bold">Products Summary : </p>
                                <div className='mt-4'>
                                    <Order_product_tab data={order_products} />

                                </div>
                            </CardBody>
                            <CardFooter>
                                <div className='d-flex justify-content-between '>

                                    <p className='display-4 p-2 rounded border font-weight-bold'>Total Amount: {Order_data?.amount} AED /- </p>
                                    <a className='btn btn-primary ' target='_blank' href={Order_data?.pdfFile}>Download Invoice</a>
                                </div>
                            </CardFooter>
                        </Card>
                    </Col>
                    <Col md="4">
                        <Card className="card-user">
                            <CardBody>
                                <CardText />
                                <p className="display-4 font-weight-bold mb-3">Order Delivery Status </p>
                                <div className="col">
                                    <div className="timeline-steps aos-init aos-animate" data-aos="fade-up">
                                        <div className="timeline-step">
                                            <div className="timeline-content" data-toggle="popover" data-trigger="hover" data-placement="top" title="" data-content="And here's some amazing content. It's very engaging. Right?" data-original-title="2003">
                                                {order_status.status == 'pending' ? <div className="full-circle" ></div> : <div className="inner-circle"></div>}
                                                <p className="h6 mt-1 mb-1" style={{ fontSize: '0.6em' }}>Pending</p>

                                            </div>
                                        </div>
                                        <div className="timeline-step">
                                            <div className="timeline-content" data-toggle="popover" data-trigger="hover" data-placement="top" title="" data-content="And here's some amazing content. It's very engaging. Right?" data-original-title="2004">
                                                {order_status.status == 'approved' ? <div className="full-circle" ></div> : <div className="inner-circle"></div>}
                                                <p className="h6 mt-1 mb-1" style={{ fontSize: '0.6em' }}>Approved</p>

                                            </div>
                                        </div>
                                        {/* <div className="timeline-step">
                                            <div className="timeline-content" data-toggle="popover" data-trigger="hover" data-placement="top" title="" data-content="And here's some amazing content. It's very engaging. Right?" data-original-title="2005">
                                                {order_status.status == 'production' ? <div className="full-circle" ></div> : <div className="inner-circle"></div>}
                                                <p className="h6 mt-1 mb-1" style={{ fontSize: '0.6em' }}>production</p>

                                            </div>
                                        </div> */}
                                        <div className="timeline-step">
                                            <div className="timeline-content" data-toggle="popover" data-trigger="hover" data-placement="top" title="" data-content="And here's some amazing content. It's very engaging. Right?" data-original-title="2010">
                                                {order_status.status == 'shipped' ? <div className="full-circle" ></div> : <div className="inner-circle"></div>}
                                                <p className="h6 mt-1 mb-1" style={{ fontSize: '0.6em' }}>Out for Delivery</p>
                                            </div>
                                        </div>
                                        <div className="timeline-step mb-0">
                                            <div className="timeline-content" data-toggle="popover" data-trigger="hover" data-placement="top" title="" data-content="And here's some amazing content. It's very engaging. Right?" data-original-title="2020">
                                                {order_status.status == 'delivered' ? <div className="full-circle" ></div> : <div className="inner-circle"></div>}
                                                <p className="h6 mt-1 mb-1" style={{ fontSize: '0.6em' }}>Delivered</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p>Current Status : {order_status?.status == 'pending' ? 'Pending' : order_status?.status == 'approved' ? 'Approved' : order_status?.status == 'production' ? 'production' : order_status?.status == 'shipped' ? 'Out For Delivery' : 'Delivered'}</p>
                                {Order_data?.isCompleted === false ? <label className=" bg-warning  px-3 mx-2 rounded text-white  font-weight-bold">Not Completed</label> : <label className=" bg-success  px-3 mx-2 rounded text-white  font-weight-bold">Completed</label>}
                                <FormGroup>
                                    <div className="d-flex flex-column justify-content-center align-items-center">
                                        <select className="custom-select mt-3 text-info" value={order_status_update.status} onChange={(e) => { setorder_status_update({ status: e.target.value }) }} >

                                            {options_status.map((status) => {
                                                return <option className='text-info' value={status.value} >{status.label}</option>
                                            })}
                                        </select>

                                        <button className="btn btn-sm mt-3  btn-secondary" type="button" onClick={changeOrderStatus}>Change Status</button>
                                    </div>

                                </FormGroup>
                            </CardBody>
                            {/* <CardFooter>
                                <div className="button-container">
                                    <Button className="btn-icon btn-round" color="facebook">
                                        <i className="fab fa-facebook" />
                                    </Button>
                                    <Button className="btn-icon btn-round" color="twitter">
                                        <i className="fab fa-twitter" />
                                    </Button>
                                    <Button className="btn-icon btn-round" color="google">
                                        <i className="fab fa-google-plus" />
                                    </Button>
                                </div>
                            </CardFooter> */}
                        </Card>
                        <Card className="card-user">
                            <CardBody>
                                <CardText />
                                <p className="display-4 font-weight-bold mb-3">Rider Status </p>
                                <div className="col">

                                </div>

                                <div className="d-flex">


                                    <div onClick={(e) => e.preventDefault()} className="ml-2" style={{ height: '50px', width: '50px' }}>
                                        <img
                                            alt="..."

                                            style={{ borderRadius: '200px', width: '100%', height: '100%' }}
                                            src='https://firebasestorage.googleapis.com/v0/b/mystory-app-9a032.appspot.com/o/images%2Fplace_holder.png?alt=media&token=6ce47f9d-9ad3-484e-b445-f78676957dc3'
                                        />

                                    </div>
                                    <div className="ml-2">
                                        <p>Rider Name:</p>
                                        <p>@Rider Company:</p>
                                    </div>



                                </div>
                                <div className="ml-2">
                                    <p className="font-weight-bold">Personal Information:</p>
                                    <p>Rider BIO</p>
                                </div>
                                <button className="btn btn-sm mt-3  btn-secondary" type="button">Contact Rider</button>

                            </CardBody>


                        </Card>
                    </Col>
                </Row>
            </div>
            <ToastContainer />

        </>
    )
}

export default ViewOrder